<template>
  <div class="static-page seller-questionnaire-page">
    <HeaderClean :header="$t('seller_questionnaire.title')" :subheader="$t('seller_questionnaire.subtitle')"/>

    <v-container tag="section" class="padding-top-35">
      <v-row class="justify-center">
        <v-col cols="12" sm="10" md="8">
          <v-form ref="form" v-model="valid">
            <v-row>
              <!-- Full Name -->
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  name="full_name"
                  :label="$t('seller_questionnaire.full_name')"
                  :persistent-hint="true"
                  :hint="$t('common.form_validations.errors.required')"
                  v-model="formData.full_name"/>
              </v-col>

              <!-- Address -->
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  name="address"
                  :label="$t('seller_questionnaire.address')"
                  :persistent-hint="true"
                  :hint="$t('common.form_validations.errors.required')"
                  v-model="formData.address"/>
              </v-col>

              <!-- Type -->
              <v-col cols="12" sm="6">
                <v-select
                  dense
                  outlined
                  :rules="[rules.required]"
                  name="type"
                  :label="$t('seller_questionnaire.type')"
                  :persistent-hint="true"
                  :hint="$t('common.form_validations.errors.required')"
                  v-model="formData.type"
                  :items="typesForSelect()"
                  item-text="text"/>
              </v-col>

              <!-- Size -->
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  name="size"
                  type="number"
                  :suffix="$t('estates.form.size_suffix')"
                  :label="$t('seller_questionnaire.size')"
                  :persistent-hint="true"
                  :hint="$t('common.form_validations.errors.required')"
                  v-model.number="formData.size"/>
              </v-col>

              <!-- Number of rooms -->
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  name="number_of_rooms"
                  type="number"
                  :label="$t('seller_questionnaire.number_of_rooms')"
                  :persistent-hint="true"
                  :hint="$t('common.form_validations.errors.required')"
                  v-model.number="formData.number_of_rooms"/>
              </v-col>

              <!-- What do you like the most in the house -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.what_do_you_like_most')"
                  v-model="formData.what_do_you_like_most"/>
              </v-col>

              <!-- What area in the house is "you" -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.what_area_is_you')"
                  v-model="formData.what_area_is_you"/>
              </v-col>

              <!-- Is there any unique in the house that worth mentioning? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.unique_worth_mentioning')"
                  v-model="formData.unique_worth_mentioning"/>
              </v-col>

              <!-- How does the house serves you daily? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.how_serves_daily')"
                  v-model="formData.how_serves_daily"/>
              </v-col>

              <!-- What hobbies does the house enables you? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.hobbies_enables')"
                  v-model="formData.hobbies_enables"/>
              </v-col>

              <!-- What special memory or experience do you have from this house? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.special_memory')"
                  v-model="formData.special_memory"/>
              </v-col>

              <!-- How would you describe the atmosphere in the house in one word -->
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  outlined
                  :label="$t('seller_questionnaire.atmosphere_one_word')"
                  v-model="formData.atmosphere_one_word"/>
              </v-col>

              <!-- What is the most pleasant thing in the neighborhood? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.most_pleasant_neighborhood')"
                  v-model="formData.most_pleasant_neighborhood"/>
              </v-col>

              <!-- What is important to know about the area for whom doesn't familiar with it? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.important_to_know_area')"
                  v-model="formData.important_to_know_area"/>
              </v-col>

              <!-- What would you like the buyer to feel when he steps into the house for the first time? -->
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  auto-grow
                  rows="3"
                  :label="$t('seller_questionnaire.what_buyer_should_feel')"
                  v-model="formData.what_buyer_should_feel"/>
              </v-col>
            </v-row>

            <v-row class="padding-top-20">
              <v-col cols="12" class="text-center">
                <v-btn
                  color="primary"
                  large
                  :disabled="!valid || btnDisabled"
                  @click="submitForm"
                  :loading="btnDisabled">
                  {{ $t('common.submit') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="5000">
            {{ snackbarMessage }}
          </v-snackbar>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HeaderClean from '@/app/common/components/header-clean'
import rules from '@/common/mixins/validations-rules-mixin.js'
import { types as Types } from '@/common/mixins/estates/estate-types-mixin'
import { Api } from '@/common/services/api-service.js'

export default {
  name: 'SellerQuestionnaire',

  components: {
    HeaderClean
  },

  mixins: [rules],

  data () {
    return {
      valid: false,
      btnDisabled: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      formData: {
        full_name: '',
        address: '',
        type: '',
        size: null,
        number_of_rooms: null,
        what_do_you_like_most: '',
        what_area_is_you: '',
        unique_worth_mentioning: '',
        how_serves_daily: '',
        hobbies_enables: '',
        special_memory: '',
        atmosphere_one_word: '',
        most_pleasant_neighborhood: '',
        important_to_know_area: '',
        what_buyer_should_feel: ''
      }
    }
  },

  methods: {
    typesForSelect () {
      return Object.keys(Types).reduce((types, k) => {
        types.push({
          text: this.$t(`estates.categories.${k}`),
          value: this.$t(`estates.categories.${k}`)
        })
        return types
      }, [])
    },

    async submitForm () {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      this.btnDisabled = true
      try {
        await Api.post('/seller-questionnaire', this.formData)

        this.snackbarMessage = this.$t('seller_questionnaire.success_message')
        this.snackbarColor = 'success'
        this.snackbar = true

        // Redirect to home page after successful submission
        setTimeout(() => {
          this.$router.push({ name: 'home' })
        }, 2000)
      } catch (e) {
        console.error(e)
        this.snackbarMessage = this.$t('seller_questionnaire.error_message') || this.$t('common.error_message')
        this.snackbarColor = 'error'
        this.snackbar = true
        this.btnDisabled = false
      }
    }
  },

  metaInfo () {
    return {
      title: this.$t('seller_questionnaire.meta_title'),
      meta: [
        {
          name: 'robots',
          content: 'noindex',
          vmid: 'robots'
        },
        {
          property: 'og:title',
          content: this.$t('seller_questionnaire.meta_title'),
          vmid: 'og:title'
        },
        {
          property: 'og:description',
          content: this.$t('seller_questionnaire.meta_description'),
          vmid: 'og:description'
        },
        {
          property: 'description',
          content: this.$t('seller_questionnaire.meta_description'),
          vmid: 'description'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.seller-questionnaire-page {
  form {
    padding: 20px 0;
  }
}
</style>
